import Sudoku from "./src/Sudoku";
export default Sudoku;
